









import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import { ICatalogCategoryItem } from '~/assets/interfaces/catalog'

@Component({
  components: {
    ComponentHeaderWithLink: () =>
      import('~/components/header/header-with-link.vue'),
    ComponentCategoriesType1: () =>
      import('~/components/catalog/category/categories-type-1.vue'),
    ComponentCategoriesType2: () =>
      import('~/components/catalog/category/categories-type-2.vue'),
    ComponentMobileCategoriesType2: () =>
      import('~/components/mobile/catalog/category/m-categories-type-2.vue'),
  },
})
export default class ComponentPageIndexCategoriesContent extends mixins(
  MixinGeneral
) {
  @Prop({ type: Array, default: () => [] })
  readonly items!: ICatalogCategoryItem[]

  @Prop({ type: String, default: '' }) readonly title!: string
  @Prop({ type: Number, default: 1 }) readonly type!: number

  private get getCategoriesType() {
    switch (this.type) {
      case 1:
        return 'component-categories-type1'
      case 2:
        return this.isMobile
          ? 'component-mobile-categories-type2'
          : 'component-categories-type2'
      default:
        return 'component-categories-type1'
    }
  }
}
